import { BaseTransformationVisitor } from './baseTransformation.visitor';
import { SortExpressionPlainObject } from '../plainObjects/sortExpression.plainObject';
import { BaseSortPlainObject } from '../plainObjects/baseSort.plainObject';

export class BaseSortVisitor extends BaseTransformationVisitor {
    private get _sortTransformation(): BaseSortPlainObject {
        return this.transformation as BaseSortPlainObject;
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public visitBasicFunction(context: any): any {
        const sortExpression = new SortExpressionPlainObject();
        const expressions = context.expression();
        sortExpression.ascending = this._getText(context.basicName()) === 'asc';
        sortExpression.expression = expressions[0] ? this._getText(expressions[0]) : '';
        sortExpression.nullsFirst = expressions[1] && this._getText(expressions[1]) === 'true';
        this._sortTransformation.sortExpressions.push(sortExpression);
    }
}
